import { API_BASE_URL } from 'shared/constants';
import { ImageRendition } from 'shared/types';

const getProductImage = (id: string, rendition: ImageRendition) =>
  `${API_BASE_URL}v1/assets/${id}/${rendition}`;

export default getProductImage;
